module.exports = __webpack_public_path__ + "img/Bakery Pastry & Ice Cream.d26c71a9.svg";